import React from "react";
import { useTranslation } from "react-i18next";
import { CoreModal } from "../core-modal";
import { FREE_LIMIT, TransElement } from "../../../../utils";
import image from "../images/project-limit-img.png";
import { useReactiveVar } from "@apollo/client";
import { projectLimitModal } from "../../../../graphql/state";

export const ProjectLimitModal = () => {
  const { t } = useTranslation();
  const show = useReactiveVar(projectLimitModal);
  const onCancel = () => projectLimitModal(false);

  return (
    <CoreModal
      show={show}
      onCancel={onCancel}
      image={{
        src: image,
        width: 228,
        height: 184,
      }}
      title={t("payment.projectLimitTitle")}
      text={{
        innerText: (
          <TransElement
            i18nKey="payment.prjectLimitText"
            values={{ count: FREE_LIMIT.PROJECT }}
            components={{ br: <br /> }}
          />
        ),
      }}
    />
  );
};
